<template>
    <Head>
        <title>Транзакции: История V3</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <template #header>
            <v-navigation/>
        </template>

        <div class="flex flex-col gap-4 py-8">

            <div class="flex flex-row justify-between items-baseline px-6">
                <h1 class="text-2xl font-bold">Транзакции: История V3</h1>
                <v-button type="button" color="green" @click="upload.show = !upload.show">Выгрузка</v-button>
            </div>

            <div class="flex flex-row justify-between px-6 items-end">
                <form action="#" method="get" class="flex flex-row gap-4 w-96 items-end" @submit.prevent="paginate(1)">
                    <v-input type="search" label="Поиск" placeholder="id/address/hash" class="w-96" v-model="search"/>
                    <v-button>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                        </svg>
                    </v-button>
                </form>
                <form v-show="upload.show" action="#" method="get" class="flex flex-row gap-4 items-end" @submit.prevent="upload.form.post(upload.url)">
                    <v-input type="date" label="Дата начала" v-model="upload.form.from"/>
                    <v-input type="date" label="Дата завершения" v-model="upload.form.to"/>
                    <v-button>Запустить</v-button>
                </form>
            </div>

<!--            body-->
            <div class="relative flex flex-col bg-white text-sm">

                <div class="grid grid-cols-12 items-end px-6 py-2 gap-x-4 font-bold sticky left-0 top-0 right-0 bg-white border-b">
                    <span>Инициатор</span>
                    <span class="text-center">Тип и статус</span>
                    <span class="col-span-3"></span>
                    <span class="text-right">Сумма</span>
                    <span>Валюта</span>
                    <span class="col-span-2">Комиссия сети</span>
                    <span class="col-span-2">Комиссия сервиса</span>
                    <span>Создана (UTC)</span>
                </div>

                <div class="grid grid-cols-12 items-center border-t px-6 py-2 gap-x-4" v-for="r of result.rows">

                    <div class="flex flex-col">
                        <Link v-if="r.organizationId" :href="route('organization', r.organizationId)"
                              class="cursor-pointer text-blue-700">
                            {{ r.organizationAlias }}
                        </Link>
                        <Link v-if="r.organizationOwnerId" :href="route('ocp.user', r.organizationOwnerId)"
                              class="text-xs cursor-pointer text-blue-700">
                            {{ r.organizationOwnerEmail }}
                        </Link>
                    </div>

                    <div class="flex flex-col items-center gap-6 text-xs">
                        <span class="uppercase text-center">{{ r.transactionType.split('_').join(' ') }}</span>
                        <span class="uppercase text-center">{{ r.status.split('_').join(' ') }}</span>
                    </div>

                    <div class="col-span-5 grid grid-cols-5 gap-x-2">

                        <v-label class="col-span-full">Address From</v-label>
                        <span class="col-span-3 font-mono">{{ r.addressFrom || '-' }}</span>
                        <span class="text-right font-mono">{{ r.amountFrom }}</span>
                        <div class="flex flex-row gap-2">
                            <span>{{ r.currencyFrom }}</span><span>{{ r.networkFrom }}</span>
                        </div>

                        <v-label class="col-span-full">Address To</v-label>
                        <span class="col-span-3 font-mono">{{ r.addressTo || '-' }}</span>
                        <span class="text-right font-mono">{{ r.amountTo }}</span>
                        <div class="flex flex-row gap-2">
                            <span>{{ r.currencyTo }}</span><span>{{ r.networkTo }}</span>
                        </div>

                        <v-label class="col-span-full">TX Hash</v-label>
                        <span class="col-span-full font-mono">{{ r.txHash || '-' }}</span>

                    </div>

                    <div class="col-span-2 flex flex-col">
                        <v-label>From {{ r.networkFeeFromSource }}</v-label>
                        <div class="flex flex-row gap-2 flex-nowrap">
                            <span class="font-mono">{{ r.networkFeeFrom }}</span>
                            <span>{{ r.currencyFrom }}</span>
                        </div>
                        <div class="flex flex-row gap-4 flex-wrap">
                            <div class="flex flex-row gap-2 flex-nowrap">
                                <span class="font-mono">{{ r.networkFeeFromUSD }}</span>
                                <span>$</span>
                            </div>
                            <div class="flex flex-row gap-2 flex-nowrap">
                                <span class="font-mono">{{ r.networkFeeFromEUR }}</span>
                                <span>€</span>
                            </div>
                        </div>

                        <v-label>To {{ r.networkFeeToSource }}</v-label>
                        <span class="font-mono">{{ r.networkFeeTo }}</span>

                        <v-label>External</v-label>
                        <span class="font-mono">{{ r.externalNetworkFee }}</span>
                    </div>

                    <div class="col-span-2 flex flex-col">
                        <div class="flex flex-row gap-2 flex-nowrap">
                            <span class="font-mono">{{ r.serviceFee }}</span>
                            <span>{{ r.currencyFrom }}</span>
                        </div>
<!--                        <div class="flex flex-row gap-2 flex-nowrap">-->
<!--                            <span class="font-mono">{{ r.serviceFeeInCurrency }}</span>-->
<!--                            <span>{{ r.currencyFrom }}</span>-->
<!--                        </div>-->
                        <div class="flex flex-row gap-4 flex-wrap">
                            <div class="flex flex-row gap-2 flex-nowrap">
                                <span class="font-mono">{{ r.serviceFeeUSD }}</span>
                                <span>$</span>
                            </div>
                            <div class="flex flex-row gap-2 flex-nowrap">
                                <span class="font-mono">{{ r.serviceFeeEUR }}</span>
                                <span>€</span>
                            </div>
                        </div>
                    </div>

                    <div class="text-center">
                        {{ moment(r.createdAt).utc().format('L LTS') }}
                    </div>

                    <div v-if="r.showDetails" class="col-span-full grid grid-cols-3 p-2 bg-gray-100">

                        <div v-for="i of ['isParent', 'id', 'operationId',
                                'errorMessage', 'parentOperationId', 'exchangeName',
                                'exchangeAddressFrom', 'exchangeAddressTo', 'exchangeTxFrom', 'exchangeTxTo',
                                'successWebhookUrl', 'errorWebhookUrl', 'returnUrl', 'advanceBalanceStart',
                                'advanceBalanceFinish', 'advanceBalanceStartTs', 'advanceBalanceFinishTs',
                                'advanceBalanceFullComissionUSD', 'advanceBalanceFullComissionEUR',
                                'advanceBalanceNetworkFeeUSD', 'advanceBalanceNetworkFeeEUR',
                                'advanceBalanceServiceFeeAmountUSD', 'advanceBalanceServiceFeeAmountEUR',
                                'advanceBalanceNetworkFeePercent', 'advanceBalanceServiceFeePercent',
                                'isOrphan', 'orphanId'
                                ]">
                            <v-label class="capitalize">{{ i.replace(/([a-z])([A-Z])/g, '$1 $2') }}</v-label>
                            <span class="font-mono">{{ r[i] || '-' }}</span>
                        </div>

                    </div>

                    <div class="col-span-full text-center text-xs p-2">
                        <span v-if="r.showDetails" class="cursor-pointer hover:font-bold" @click="r.showDetails = false">Скрыть</span>
                        <span v-else class="cursor-pointer hover:font-bold" @click="r.showDetails = true">Подробнее</span>
                    </div>

                </div>

            </div>
<!--            <pre class="bg-white text-xs">{{ result.rows }}</pre>-->
<!--            end body -->

            <div class="flex flex-row justify-center">
                <v-pagination :count="parseInt(result.count)" :page="page" :limit="limit" :paginate="paginate" />
            </div>

        </div>



    </authenticated-layout>

</template>

<script>
import moment from "moment";
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/Transactions';
import VLabel from "@/Components/Label";
import VInput from "@/Components/Input";
import VButton from "@/Components/Button";
import VSelect from "@/Components/Select";
import VPagination from "@/Components/PaginationOffset";
import TransactionStatusIcon from "@/Components/Icons/TransactionStatus";

export default {
    components: {
        Head, Link, useForm,
        AuthenticatedLayout,
        VNavigation,
        VLabel,
        VInput,
        VButton,
        VSelect,
        VPagination,
        TransactionStatusIcon,
    },
    props: {
        success: Boolean,
        result: Object,
        notifications: Array,
        limit: Number,
        page: Number,
        search: String,
    },
    data() {
        return {
            currentRoute: this.route().current(),
            upload: {
                show: false,
                form: useForm({
                    from: moment().startOf('month').format('YYYY-MM-DD'),
                    to: moment().format('YYYY-MM-DD'),
                }),
                url: this.route('transactions.history.v3.upload'),
            },
        }
    },
    methods: {
        moment,
        paginate(toPage = null) {
            const { page, search } = this;

            useForm({
                page: toPage || page,
                search
            }).get(this.route(this.currentRoute));
        },
    },
}
</script>
